var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isshow
    ? _c(
        "div",
        [
          _c("div", { staticStyle: { height: "5px", background: "#f2f2f2" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "5px" } },
            [
              _c(
                "van-tabs",
                {
                  attrs: { "line-width": 0 },
                  on: { change: _vm.change },
                  model: {
                    value: _vm.active,
                    callback: function($$v) {
                      _vm.active = $$v
                    },
                    expression: "active"
                  }
                },
                _vm._l(_vm.data, function(item, index) {
                  return _c("van-tab", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        attrs: { slot: "title" },
                        slot: "title"
                      },
                      [
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.labelName) +
                              "\n            "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      item.children &&
                      item.children.length > 0 &&
                      _vm.cnt(item.children)
                        ? _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _c(
                                "van-collapse",
                                {
                                  model: {
                                    value: item.activeNames,
                                    callback: function($$v) {
                                      _vm.$set(item, "activeNames", $$v)
                                    },
                                    expression: "item.activeNames"
                                  }
                                },
                                [
                                  _vm._l(item.children, function(
                                    childrenItem,
                                    childrenIndex
                                  ) {
                                    return [
                                      childrenItem.use == 1
                                        ? _c(
                                            "van-collapse-item",
                                            {
                                              key: childrenIndex,
                                              attrs: {
                                                title: childrenItem.labelName,
                                                name: childrenItem.childrenIndex
                                              }
                                            },
                                            [
                                              _vm._l(
                                                _vm.filterByType(
                                                  childrenItem.children,
                                                  2
                                                ),
                                                function(info, infoIndex) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        "child-" +
                                                        info.id +
                                                        "-" +
                                                        infoIndex
                                                    },
                                                    [
                                                      info.use == 1
                                                        ? _c(
                                                            "van-tag",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  info.type == 2
                                                                    ? "red"
                                                                    : "#000",
                                                                size: "large"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  info.labelName
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.filterByType(
                                                  childrenItem.children,
                                                  1
                                                ),
                                                function(info, infoIndex) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key:
                                                        "child-" +
                                                        info.id +
                                                        "-" +
                                                        infoIndex
                                                    },
                                                    [
                                                      info.use == 1
                                                        ? _c(
                                                            "van-tag",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  info.type == 2
                                                                    ? "red"
                                                                    : "#000",
                                                                size: "large"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  info.labelName
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticStyle: { "margin-top": "1.2rem" } },
                            [
                              item.labelName == "消费行为"
                                ? _c(
                                    "van-collapse",
                                    {
                                      model: {
                                        value: _vm.tagNames,
                                        callback: function($$v) {
                                          _vm.tagNames = $$v
                                        },
                                        expression: "tagNames"
                                      }
                                    },
                                    [
                                      _c(
                                        "van-collapse-item",
                                        {
                                          attrs: {
                                            title: "消费信息",
                                            name: "1"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "basic-information-flex"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "basic-information-lists"
                                                },
                                                [
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "购买徕卡学院课程总次数"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .total_course_purchases
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "产品类订单累计消费金额"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .U_TotalSalesAmount !=
                                                                null
                                                                ? _vm
                                                                    .$numeral(
                                                                      _vm
                                                                        .extData
                                                                        .U_TotalSalesAmount
                                                                    )
                                                                    .format(
                                                                      "0,0.00"
                                                                    )
                                                                : ""
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "服务类订单累计消费金额"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .U_TotalService_orderAmout !=
                                                                null
                                                                ? _vm
                                                                    .$numeral(
                                                                      _vm
                                                                        .extData
                                                                        .U_TotalService_orderAmout
                                                                    )
                                                                    .format(
                                                                      "0,0.00"
                                                                    )
                                                                : ""
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "van-collapse-item",
                                        {
                                          attrs: {
                                            title: "拥有产品",
                                            name: "2"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "basic-information-flex"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "basic-information-lists"
                                                },
                                                [
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [_vm._v("购买相机系列")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .U_OwnerCamera
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [_vm._v("购买镜头系列")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .U_OwnerLens
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [_vm._v("注册相机系列")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .U_RegCamera
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("li", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-item"
                                                      },
                                                      [_vm._v("注册镜头系列")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "basic-information-lists-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.extData
                                                                .U_RegLens
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "van-collapse-item",
                                        {
                                          attrs: {
                                            title: "购买产品",
                                            name: "3"
                                          }
                                        },
                                        [
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [_vm._v("购买相机数量")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_TotalCamera
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [_vm._v("购买镜头数量")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_TotalLens
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买运动光学数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_TotalSportoptiks
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [_vm._v("购买配件数量")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_TotalAccessories
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买Q相机数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Camera_Q_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买Compact数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Camera_Compact_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买M相机数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Camera_M_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买M镜头数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Lens_M_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买SL相机数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Camera_SL_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买SL镜头数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Lens_SL_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买APS相机数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Camera_APS_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买APS镜头数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Lens_APS_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买M-Kit数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Kit_M_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买SL-Kit数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Kit_SL_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "11" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买APS-Kit数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Kit_APS_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  attrs: {
                                                    offset: "2",
                                                    span: "11"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "购买Compact-Kit数量"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "basic-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.extData
                                                                  .U_Kit_Compact_No
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "tabsub" },
                                    [_c("empty")],
                                    1
                                  )
                            ],
                            1
                          )
                    ])
                  ])
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-popup",
            {
              model: {
                value: _vm.tagEdit,
                callback: function($$v) {
                  _vm.tagEdit = $$v
                },
                expression: "tagEdit"
              }
            },
            [
              _c("div", { staticClass: "add-model" }, [
                _c("div", { staticClass: "addClientTitle" }, [
                  _vm._v("\n        选择客户标签\n        "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("提示：单击选择，再次点击取消。")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "popInfo" },
                  [
                    _c(
                      "van-collapse",
                      {
                        model: {
                          value: _vm.activeNames,
                          callback: function($$v) {
                            _vm.activeNames = $$v
                          },
                          expression: "activeNames"
                        }
                      },
                      _vm._l(_vm.model, function(item, index) {
                        return _c(
                          "van-collapse-item",
                          {
                            key: index + "" + item.id,
                            attrs: { title: item.labelName, name: item.id }
                          },
                          [
                            _c("div", { staticClass: "tabsub" }, [
                              item.children && item.children.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "tabNav" },
                                    _vm._l(item.children, function(
                                      childrenItem,
                                      childrenIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key:
                                            childrenIndex +
                                            "" +
                                            childrenItem.id,
                                          staticClass: "navItem",
                                          class: {
                                            "navItem--active":
                                              item.active == childrenItem.id ||
                                              (!item.active &&
                                                childrenIndex == 0)
                                          },
                                          attrs: { title: childrenItem.id },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.handTreeTab(
                                                item,
                                                childrenItem.id,
                                                childrenIndex
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(childrenItem.labelName) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.children && item.children.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "tabcontent" },
                                    [
                                      _vm._l(item.children, function(
                                        childrenItem,
                                        childrenIndex
                                      ) {
                                        return [
                                          item.active == childrenItem.id ||
                                          (!item.active && childrenIndex == 0)
                                            ? _c(
                                                "div",
                                                {
                                                  key: childrenItem.id,
                                                  staticClass: "conItem",
                                                  attrs: {
                                                    title:
                                                      childrenItem.labelName
                                                  }
                                                },
                                                _vm._l(
                                                  childrenItem.children,
                                                  function(info, infoIndex) {
                                                    return _c(
                                                      "span",
                                                      { key: infoIndex },
                                                      [
                                                        info.type == 2
                                                          ? _c(
                                                              "van-tag",
                                                              {
                                                                attrs: {
                                                                  plain:
                                                                    info.use !==
                                                                    1,
                                                                  color:
                                                                    info.use ==
                                                                    1
                                                                      ? "red"
                                                                      : "#000",
                                                                  size: "large"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.handTag(
                                                                      info
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    info.labelName
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e()
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "confirm-cancel" }, [
                  _c(
                    "div",
                    { staticClass: "button-flex-color flex-border-button" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "button-flex-item",
                          on: {
                            click: function($event) {
                              _vm.tagEdit = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "button-flex-color" }, [
                    _c(
                      "div",
                      {
                        staticClass: "button-flex-item button-active",
                        on: {
                          click: function($event) {
                            return _vm.saveLabel()
                          }
                        }
                      },
                      [_vm._v("确定")]
                    )
                  ])
                ])
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac38129", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac38129","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/tagInfo.vue
// module id = null
// module chunks = 